<kendo-combobox [data]="initiatives"
                [textField]="'title'"
                [valueField]="'customerInitiativeID'"
                [valuePrimitive]="false"
                [allowCustom]="false"
                [(ngModel)]="selectedInitiative"
                (selectionChange)="selectedInitiativeChanged.emit($event)">
</kendo-combobox>
